<template>
  <td class="left title" :class="wrapClass">
    <span class="link_modal" @click="$emit('click')">{{stripValue}}</span>
    <ToolTip v-if="isEdited">
      (수정됨)
      <template #content>
        <dt class="tit">마지막 수정 시간</dt>
        <dd class="cont">{{$utils.timeText(rowData.updateDate)}}</dd>
      </template>
    </ToolTip>
  </td>
</template>

<script>
export default {
  props: {
    value: String,
    rowData: Object,
    wrapClass: String,
    maxLength: {
      type: Number,
      default: 20
    }
  },
  computed: {
    stripValue() {
      return this.value.length > this.maxLength
        ? this.value.slice(0, this.maxLength).concat("...")
        : this.value;
    },
    isEdited() {
      return this.rowData.createDate != this.rowData.updateDate;
    }
  }
};
</script>

<style>
</style>
